module.exports = __webpack_public_path__ + "static/media/checkbox_checked.e320d64a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/checkbox_checked.svg
// module id = 231
// module chunks = 0